import { render, staticRenderFns } from "./InsightsDesempenho.vue?vue&type=template&id=f6bbd91e&scoped=true"
import script from "./InsightsDesempenho.vue?vue&type=script&lang=js"
export * from "./InsightsDesempenho.vue?vue&type=script&lang=js"
import style0 from "./InsightsDesempenho.vue?vue&type=style&index=0&id=f6bbd91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bbd91e",
  null
  
)

export default component.exports